import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import cs from 'classnames'

const MODAL_SIZES = {
    sm: 440,
    md: 640,
    lg: 845,
    xl: 1115
}
const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    paper: ({ size }) => ({
        margin: 32,
        backgroundColor: theme.background,
        border: theme.border,
        padding: 50,
        borderRadius: theme.borderRadius,
        outline: 0,
        width: size ? MODAL_SIZES[size] : MODAL_SIZES.md,
        minWidth: 440
    })
}))

export default function TransitionsModal({
    open,
    setOpen,
    children,
    className,
    onClose,
    size,
    style
}) {
    const classes = useStyles({ size })

    const close = () => {
        setOpen ? setOpen(false) : onClose?.()
    }

    return (
        <Modal
            className={classes.modal}
            open={open}
            onClose={close}
            closeAfterTransition
            BackdropComponent={Backdrop}
            style={style}
            BackdropProps={{
                timeout: 500
            }}>
            <Fade in={open}>
                <div className={cs([classes.paper, className])}>{children}</div>
            </Fade>
        </Modal>
    )
}
